export type Option = {
  value: string | number;
  label: string;
};

export const getDropdownOptionFromValue = (
  options: Option[],
  value: string | number
) => {
  const foundOption = options.find((option) => option.value === value) || null;
  return foundOption;
};

export const getDropdownOptionFromLabel = (
  options: Option[],
  label: string
) => {
  const foundOption = options.find((option) => option.label === label) || null;
  return foundOption;
};

export const getValueFromDropdownOption = (
  options: Option[],
  value: string | number
) => {
  const foundValue =
    options.find((option) => option.value === value)?.value || null;
  return foundValue;
};

export const getOptionsFromArray = (array: string[]): Option[] => {
  return array.map((item) => ({
    value: item,
    label: item,
  }));
};
